import React from 'react'
import "./menu.css"
// import { Link } from 'react-router-dom'
import img1 from "../assest/imgs/AI1.jpg";
import img2 from "../assest/imgs/Hardware1.jpg";
import img3 from "../assest/imgs/Apps1.jpg";
import img4 from "../assest/imgs/Programming1.jpg";
import img5 from "../assest/imgs/Apps2.jpg";
const Menu = () => {
    const posts =[
        {
          id:1,
          title: "Lorem ipsum dolor, sit amet consectetur adipisicing.",
          desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor sunt fugiat voluptatibus eligendi adipisci eveniet facere culpa incidunt labore in odio aspernatur quasi vero ipsum repellendus, rerum similique voluptatem neque!",
          img: img1
        },
        {
          id:2,
          title: "Lorem ipsum dolor, sit amet consectetur adipisicing.",
          desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor sunt fugiat voluptatibus eligendi adipisci eveniet facere culpa incidunt labore in odio aspernatur quasi vero ipsum repellendus, rerum similique voluptatem neque!",
          img: img2
        },
        {
          id:3,
          title:  "Lorem ipsum dolor, sit amet consectetur adipisicing.",
          desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor sunt fugiat voluptatibus eligendi adipisci eveniet facere culpa incidunt labore in odio aspernatur quasi vero ipsum repellendus, rerum similique voluptatem neque!",
          img:img3
        },
        {
          id:4,
          title:  "Lorem ipsum dolor, sit amet consectetur adipisicing.",
          desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor sunt fugiat voluptatibus eligendi adipisci eveniet facere culpa incidunt labore in odio aspernatur quasi vero ipsum repellendus, rerum similique voluptatem neque!",
          img: img4
        },
        {
          id:5,
          title:  "Lorem ipsum dolor, sit amet consectetur adipisicing.",
          desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor sunt fugiat voluptatibus eligendi adipisci eveniet facere culpa incidunt labore in odio aspernatur quasi vero ipsum repellendus, rerum similique voluptatem neque!",
          img:img5
        }
      ];
  return (
    <div className='menu'>
        <h1>Other posts you may like !</h1>
        {posts.map(post=>(
            <div className="post" key={post.id}>
                <img src={post.img}alt=''/>
                <h2>{post.title}</h2>
                <button>Read More</button>
            </div>
        ))}

    </div>
  )
}

export default Menu